export default "__VITE_ASSET__DnRmUx69__"